import { SpyneTrait } from "spyne";
import { ScrollSpySingleton } from "traits/utils/scroll-spy-singleton";

const _scrollSpy = new ScrollSpySingleton();
export class ScrollSpyTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = "scrollSpy$";

    super(context, traitPrefix);
  }

  static scrollSpy$ObserverAdd(props = this?.props) {
    const isValidType = this.scrollSpy$ObserverCheckIfValidBlockItem(props);

    const el = props?.el;

    if (isValidType === true && el !== undefined) {
     // this.props.isObserved = true;
     // _scrollSpy.addSectionObserver(el);
    }
  }

  static scrollSpy$ObserverCheckIfValidBlockItem(
    props = this?.props,
    validItemsArr = ["stage", "section", "topic", "subtopic"],
  ) {
    const itemType = props?.data?.menuData?.itemType;
    return validItemsArr.includes(itemType);
  }

  static scrollSpy$ObserverRemove(props = this?.props) {
    const isValidType = this.scrollSpy$ObserverCheckIfValidBlockItem(props);

    const el = props?.el;

    if (isValidType === true && el !== undefined) {
      _scrollSpy.removeSectionObserver(el);
    }
  }

  static scrollSpy$ResetDisableScrollSpy(props = this.props) {
    if (props?.disableScrollSpy) {
      props.disableScrollSpy = false;
    }
    //consol.log("DATA ARR CALLED RESET DISABLE ",props.disableScrollSpy);
  }

  static scrollSpy$PauseScrollSpy(props = this.props) {
    try {
      if (props !== undefined) {
        props.disableScrollSpy = true;

        let timeoutID = props.id;

        const resetDisableScrollSpy = () => {
          props.disableScrollSpy = false;

          //console.log("SCROLL SPY READY",this.props.disableScrollSpy);
        };

        function callOrResetTimeout(callback) {
          if (timeoutID) {
            clearTimeout(timeoutID);
          }
          timeoutID = setTimeout(() => {
            callback();
            timeoutID = null; // Reset the timeoutID after execution
          }, 2550);
        }

        callOrResetTimeout(this.scrollSpy$ResetDisableScrollSpy.bind(this));
      }
    } catch (e) {
     //console.log("scroll spyne error ", e);
    }
  }

  static scrollSpy$SubscribeAndSendToRoute(props = this.props) {
    const onSubscribeToIntersections = (dataArr) => {
      const isValidData = Array.from(dataArr).length === 1;
      //consol.log("DATA ARR IS ",this?.props?.disableScrollSpy, {isValidData,dataArr},dataArr[0].target.dataset);

      if (this?.props?.disableScrollSpy === false) {
        0;
        const payload = { ...dataArr[0].target.dataset };
       //console.log("PAYLOAD IS ", payload);

        if (payload?.pageId !== "docs3" && payload?.stage !== "intro" && payload?.stage !== "ex3amples") {
          this.sendInfoToChannel("CHANNEL_ROUTE", payload);
        }
      }
    };

    const { intersections$ } = _scrollSpy;

    intersections$.subscribe(onSubscribeToIntersections);

    //console.log('scroll spy page docs ',intersections$);
  }
}
